
define(
	'eComm.SegmentationExtension.1.0.0.ShoppingEntryPoint'
,   [
		'CallForPricing',
		'Footer.Segmentation.View',
		'Categories.Segmentation'
	]
,   function (
		CallForPricing,
		FooterSegmentationView,
		CategoriesSegmentation
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container){
			CallForPricing.loadModule(container);
			CategoriesSegmentation.loadModule(container);
			FooterSegmentationView.loadModule(container);

			// var layout = container.getComponent('Layout');

			// if(layout){
			// 	layout.addChildViews('Footer.View', {
            //         'Footer.View' : {
            //             'Footer.Segmentation.View': {
            //                 childViewIndex: 5,
            //                 childViewConstructor: function childViewConstructor() {
            //                     return new FooterSegmentationView({
            //                         layout: 'layout'
            //                     });
            //                 }
            //             }
            //         }
            //     })

			// }
		}
	};
});
